// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fa-chevron-down[data-v-828e113a]{transition:all .2s ease-in-out}.rotate-180[data-v-828e113a]{transform:rotate(-180deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
